
<div
        class="carousel"
        appDraggableCarousel
>
  <ep-product-portrait-tile
    class="carousel__tile"
    *ngFor="let product of products"
    [product]="product"
    [hasAddToListButton]="hasAddToListButton"
  ></ep-product-portrait-tile>
  <ng-container *ngIf="isLoading">
    <ep-product-portrait-tile-skeleton
      class="carousel__tile"
      *ngFor="let i of [0,0,0]"
    ></ep-product-portrait-tile-skeleton>
  </ng-container>
  <ng-content></ng-content>
</div>
